import IconMenuItem from "./IconMenuItem";

export interface MenuItem {
    icon: string;
    to: string;
    hasNotif?: boolean;
}

interface IconsMenuProps {
    menu: Array<MenuItem>;
}

const IconsMenu: React.FC<IconsMenuProps> = ({ menu }) => {

    return (
        <nav className="inline-flex">
            {
                menu.map((item, idx) => (
                    <IconMenuItem {...item} key={idx} />
                ))
            }
        </nav >
    );
}

export default IconsMenu;